export const mockShippingData = {
  orderNumber: "ORD-12345678",
  trackingNumber: "SHIP1234567890",
  courierName: "ShipRocket Express",
  courierLogo:
    "https://images.pexels.com/photos/5913313/pexels-photo-5913313.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  orderDate: "2025-05-25T10:23:00Z",
  estimatedDelivery: "Thursday, May 30, 2025 by 8:00 PM",
  shipmentStatus: "In Transit",
  customer: {
    name: "John Smith",
    email: "john.smith@example.com",
    phone: "+1 (555) 123-4567",
  },
  shippingAddress: {
    street: "123 Delivery Street, Apt 4B",
    city: "New York",
    state: "NY",
    zipCode: "10001",
    country: "United States",
  },
  billingAddress: {
    street: "456 Billing Avenue",
    city: "New York",
    state: "NY",
    zipCode: "10001",
    country: "United States",
  },
  timeline: [
    {
      status: "Order Placed",
      date: "May 25, 2025",
      time: "10:23 AM",
      location: "Your Store",
      description: "Your order has been received and is being processed.",
      completed: true,
    },
    {
      status: "Order Processed",
      date: "May 26, 2025",
      time: "02:45 PM",
      location: "Fulfillment Center",
      description: "Your order has been prepared and is ready for shipping.",
      completed: true,
    },
    {
      status: "Shipped",
      date: "May 27, 2025",
      time: "11:15 AM",
      location: "Distribution Center",
      description: "Your package has been handed over to ShipRocket Express.",
      completed: true,
    },
    {
      status: "In Transit",
      date: "May 28, 2025",
      time: "09:30 PM",
      location: "Regional Hub, Chicago",
      description: "Your package is on its way to the destination.",
      completed: true,
    },
    {
      status: "Out for Delivery",
      date: "May 30, 2025",
      time: null,
      location: "Local Delivery Facility",
      description: "Your package will be delivered today.",
      completed: false,
    },
    {
      status: "Delivered",
      date: "May 30, 2025",
      time: null,
      location: "Delivery Address",
      description: "Estimated delivery by 8:00 PM.",
      completed: false,
    },
  ],
  orderItems: [
    {
      name: "Premium Wireless Headphones",
      variant: "Space Gray",
      quantity: 1,
      price: 199.99,
      originalPrice: 249.99,
      image:
        "https://images.pexels.com/photos/3394650/pexels-photo-3394650.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    },
    {
      name: "Smartphone Protective Case",
      variant: "Black",
      quantity: 1,
      price: 29.99,
      image:
        "https://images.pexels.com/photos/404280/pexels-photo-404280.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    },
    {
      name: "Fast Charging USB-C Cable",
      variant: "1.5m",
      quantity: 2,
      price: 19.98,
      originalPrice: null,
      image:
        "https://images.pexels.com/photos/4219883/pexels-photo-4219883.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    },
  ],
  orderSubtotal: 249.96,
  shippingCost: 12.99,
  tax: 20.75,
  orderTotal: 283.7,
};
